import { useContentful } from '@pcln/contentful-components'
import useContent from './useContent'

export default function useContentfulSearchFormHeadlines(
  name: string,
  shouldFireImpression = true
) {
  const searchFormResponse: any = useContentful(name)
  const searchForm = useContent(searchFormResponse, shouldFireImpression)
  return searchForm ?? null
}
